import { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles';

import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import { makeStyles } from '@mui/styles'
import {Typography, Paper, Box, IconButton, Chip } from '@mui/material'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export default function AppVersionRestaurantConfirm({
    data
}) {
    const columns = [
    {
      field: 'deviceType',
      headerName: 'Device Type',
      width: 100,
      flex: 1,
    },
    {
      field: 'buildTarget',
      headerName: 'Build Target',
      width: 100,
      flex: 1,
    },
    {
      field: 'shopAppReleaseId',
      headerName: 'Shop App Release Id',
      width: 100,
      flex: 1,
      renderCell: (params) => {
        const key = `confirm_${params.row.deviceType} + ${params.row.buildTarget}`
        const shopAppReleaseId = params.row.shopAppReleaseId
        return (
          <div key={key}>
            <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-all', my: 1 }}>
                app version: {shopAppReleaseId?.appVersion}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-all', my: 1 }}>
                buildNumber: {shopAppReleaseId?.buildNumber}
            </Typography>
            
            <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-all', my: 1 }}>
                customCode: {shopAppReleaseId?.customCode ?? '-'}
            </Typography>
          </div>
        )
      }
    },
    {
      field: 'forceUpdate',
      headerName: 'Force Update',
      width: 100,
      flex: 1,
    },
  ]

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const isDeleteMode = data?.versionConfigList?.some(item => item?.status === true)
    const countVersion = data?.versionConfigList?.reduce((grp, item) => {
        const version = item?.shopAppRelease?.id || item?.shopAppReleaseId?.id
        // Initialize the group if it doesn't exist
        if (!grp[version] && version) {
            grp[version] = [];
        }

        if (version) grp[version].push(item)
        
        return grp
    }, {})
    // const countVersion = data.versionConfigList.groupBy(item => item?.shopAppReleaseId?.id)
    // console.log('countVersion', countVersion)

    const list = isDeleteMode ? data?.versionConfigList : Object.keys(countVersion || {})

    return (
        <Box>
            <Typography variant="h5" color="text.secondary" sx={{ wordBreak: 'break-all', my: 1 }}>
                Total Restaurants: {data?.restUrlIdList?.length}
            </Typography>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            {/* <StyledTableCell align="right">buildTarget</StyledTableCell> */}
                            {
                                isDeleteMode ? (
                                    <>
                                        <StyledTableCell>Device Type</StyledTableCell>
                                        <StyledTableCell align="right">Build Target</StyledTableCell>
                                        <StyledTableCell align="right">Delete</StyledTableCell>
                                    </>
                                ) : (
                                    <>
                                        <StyledTableCell align="left">Version(s)</StyledTableCell>
                                        <StyledTableCell align="right">Count</StyledTableCell>
                                        <StyledTableCell align="right">Force Update</StyledTableCell>
                                    </>
                                )
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {list.map((row) => {
                        const version = isDeleteMode ? row.shopAppReleaseId : countVersion[row]?.[0]?.shopAppRelease || countVersion[row]?.[0]?.shopAppReleaseId
                        const countForceUpdate = () => countVersion[row]?.filter(item => item.forceUpdate)?.length

                        return (
                            <StyledTableRow key={isDeleteMode ? row?.deviceType+row?.buildTarget : row}>
                                {/* <StyledTableCell align="right">{row.buildTarget}</StyledTableCell> */}
                                {
                                    isDeleteMode ? (
                                        <>
                                            <StyledTableCell component="th" scope="row">
                                                {row.deviceType}
                                            </StyledTableCell>
                                            <StyledTableCell align="right">{row.buildTarget}</StyledTableCell>
                                            <StyledTableCell align="right">{row.status ? '✅' : '❌'}</StyledTableCell>
                                        </>
                                    ) : (
                                        <>
                                            <StyledTableCell align='left'>
                                                <Typography variant="span" color="text.secondary" sx={{ wordBreak: 'break-all', my: 1 }}>
                                                   {version?.appVersion} ({version?.buildNumber}) {version?.customCode && <Chip label={version?.customCode} variant="outlined" size="small" />}
                                                </Typography>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <Typography variant="span" color="text.secondary" sx={{ wordBreak: 'break-all', my: 1 }}>
                                                    {countVersion[row]?.length}
                                                </Typography>
                                                
                                                {/* <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-all', my: 1 }}>
                                                    customCode: {version?.customCode ?? '-'}
                                                </Typography> */}
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                {countForceUpdate()} ✅ 
                                                <br />
                                                {countVersion[row].length - countForceUpdate()} ❌ 
                                            </StyledTableCell>
                                        </>
                                    )
                                }
                            </StyledTableRow>
                        )
                    })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}